/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/PyramidLogic/ChallengeAuthorities/PlayValuesDailyPyramidAuthority',[
    'SolitaireShared/PyramidLogic/IDailyPyramidAuthority',
    'SolitaireShared/CardLogic/IPlayValuesDailyAuthority',
    'SolitaireShared/CardLogic/IDailyAuthority',
    'SolitaireShared/CardLogic/CardOp',
    'SolitaireShared/CardLogic/CardValue'
], function (IDailyPyramidAuthority, IPlayValuesDailyAuthority, IDailyAuthority, CardOp, CardValue) {
    "use strict";

    var PlayValuesDailyPyramidAuthority = function (param) {
        this.initPlayValuesDailyPyramidAuthority(param);
    };

    PlayValuesDailyPyramidAuthority.Key_NumToPlay = "NUMBERTOPLAY";
    PlayValuesDailyPyramidAuthority.Key_ValueToPlay = "VALUETOPLAY";

    var TagValueplayed = 0x10000;

    PlayValuesDailyPyramidAuthority.constructor = PlayValuesDailyPyramidAuthority;
    PlayValuesDailyPyramidAuthority.prototype = Object.create(IDailyPyramidAuthority.prototype);
    IPlayValuesDailyAuthority.call(PlayValuesDailyPyramidAuthority.prototype);

    PlayValuesDailyPyramidAuthority.prototype.initPlayValuesDailyPyramidAuthority = function (param) {
        IDailyPyramidAuthority.call(this, param);
        this._hasWon = false;
        this.SuppressBonusAnimations = true;

        var isDirty = true;
        if (param != null && param[PlayValuesDailyPyramidAuthority.Key_NumToPlay] && param[PlayValuesDailyPyramidAuthority.Key_ValueToPlay])
        {
            isDirty = false;

            this.NumToPlay = parseInt(param[PlayValuesDailyPyramidAuthority.Key_NumToPlay]);
            this.ValueToPlay = CardValue.getValue(param[PlayValuesDailyPyramidAuthority.Key_ValueToPlay]);
            this._numPlayed = 0;

            if (isNaN(this.NumToPlay) || !this.ValueToPlay) {
                isDirty = true;
            }

            if (isDirty)
                throw "Invalid parameter passed in creating Daily Challenge";
        }

        this.ChallengeType = IDailyAuthority.ChallengeType.PlayValues;

    };

    Object.defineProperty(PlayValuesDailyPyramidAuthority.prototype, "Value", {
        get: function () {
            return this.ValueToPlay;
        }
    });

    Object.defineProperty(PlayValuesDailyPyramidAuthority.prototype, "NumberToPlay", {
        get: function () {
            return this.NumToPlay;
        }
    });

    Object.defineProperty(PlayValuesDailyPyramidAuthority.prototype, "NumberPlayed", {
        get: function () {
            return this._numPlayed;
        }
    });

    PlayValuesDailyPyramidAuthority.prototype.Deal = function () {
        if(this.NumDealsLeft() == this.MaxDeals)
            this._numPlayed = 0;

        return IDailyPyramidAuthority.prototype.Deal.call(this);
    };

    PlayValuesDailyPyramidAuthority.prototype.GetScoreForAction = function (action)
    {
        for (var i = 0; i < action.Ops.length; i ++)
        {
            var op = action.Ops[i];
            var destPile = op.GetPile(CardOp.eMoveParams.DestPile);
            if (op.Opcode == CardOp.Op.Move
                && destPile.Type == "Foundation")
            {
                var numCards = action.Ops.length;
                for (var i = 1; i <= numCards; i++)
                {
                    if (destPile.NthFromTop(i).Value == this.ValueToPlay)
                    {
                        action.Tag = (action.Tag | TagValueplayed) >>> 0;
                        return  IDailyPyramidAuthority.prototype.GetScoreForAction.call(this, action);
                    }
                }
            }
        }

        return IDailyPyramidAuthority.prototype.GetScoreForAction.call(this, action);
    };

    PlayValuesDailyPyramidAuthority.prototype.OnRunSpecialAction = function (tag, undo)
    {
        if (((tag & TagValueplayed) >>> 0) != 0)
        {
            this._numPlayed += (undo ? -1 : 1);
        }

        IDailyPyramidAuthority.prototype.OnRunSpecialAction.call(this, tag, undo);
    };

    PlayValuesDailyPyramidAuthority.prototype.IsGameWon = function ()
    {
        if (this.CardSupply.IsWaitingForAds)
        {
            return false;
        }

        if (this.CheckWin() && this._numPlayed < this.NumToPlay && !this.CardSupply.WaitingForAnimation)
            this.Deal();
        return (this._numPlayed >= this.NumToPlay);
    };

    PlayValuesDailyPyramidAuthority.prototype.GetHint = function (cycle, cheat)
    {

        if(cheat) {
            return IDailyPyramidAuthority.prototype.GetHint.call(this,cycle,cheat);
        }

        cycle = !!cycle;
        var numTableaus = 28;

        var hints = [];

        var pile;
        var cards = [ "CHALLENGE" ];

        for (var i = numTableaus - 1; i >= 0; i--)
        {
            pile = this.CardSupply.GetPile("Tableau" + i);
            if (pile.Empty)
                continue;
            if (pile.Top.Value == this.ValueToPlay)
                cards.push(pile.Top.Sequence.toString());
        }
        pile = this.CardSupply.GetPile("Stock");
        if (!pile.Empty && pile.Top.Value == this.ValueToPlay)
            cards.push(pile.Top.Sequence.toString());
        pile = this.CardSupply.GetPile("Waste");
        if (!pile.Empty && pile.Top.Value == this.ValueToPlay)
            cards.push(pile.Top.Sequence.toString());

        if (cards.length > 1)
        {
            var hint = new CardOp(this.CardSupply);

            hint.Parse(cards, 0);
            hints.push(hint);
        }

        return hints.length > 0 ? hints[0] : new CardOp(this.CardSupply);
    };

    return PlayValuesDailyPyramidAuthority;


});
